import React, { useEffect, useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import { Container } from "reactstrap";
import { Button, Switch, FormGroup, FormControlLabel, TextField, Box } from "@material-ui/core";
import moment from "moment";
import "moment/locale/es";
import Swal from "sweetalert2";
import { size } from "numeral";
//

export const Login = (props) => {
    let history = useHistory();
    moment.locale("es");
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("userAccount")));
    const [recordar, setRecordar] = useState(JSON.parse(localStorage.getItem("recordar")));
    const [cbkRecordar, setCbkRecordar] = useState(true);

    useEffect(() => {
        loadRecordar();
    },[])

    const loadRecordar = () => {
        try
        {
            //localStorage.clear();
            localStorage.setItem("configuration", JSON.stringify({ alineacion: 'left', letra: '14', espaciado: '24' }));
            localStorage.setItem("modoNocturno", false);

            if (recordar == null || recordar == "")
                setCbkRecordar(true);
            else if (recordar == true)
                history.replace("/canticos/C");

        } catch (e) {
            console.error(e);
        }
    }

    const btnLogin = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            Swal.fire({
                title: 'Alerta',
                text: 'El email y la contraseña son requeridos.',
                confirmButtonText: 'Ok',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false
            })
            return;
        }

        let sendData = {
            buser_email: email,
            buser_password: password
        }

        fetch(`buser/login`, {
            method: "POST",
            body: JSON.stringify(sendData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (responseJson.serverStatus == 200) {
                    localStorage.setItem("recordar", cbkRecordar);
                    localStorage.setItem("userAccount", JSON.stringify(responseJson));
                    history.replace("/canticos/C");
                }
                else if (responseJson.serverStatus == 300) {
                    Swal.fire({
                        title: '',
                        text: responseJson.mensaje,
                        confirmButtonText: 'Ok',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false
                    })
                }else {
                    Swal.fire({
                        title: '',
                        text: 'Las credenciales no son validas.',
                        confirmButtonText: 'Ok',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false
                    })
                    console.error(responseJson[0].server)
                }
            })
            .catch((error) => {
                Swal.fire({
                    title: 'Error #2',
                    text: 'Ha ocurrido un error.',
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                })
                console.error(error);
            });
    }

    return (
        <Container>
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div
                        class="card card-signin my-5"
                    >
                        <h5 class="card-title primary text-center">Coritario I.E.R.</h5>
                        <div class="form-signin">

                            <div className="form-group">
                                <TextField
                                    required
                                    id="outlined-required"
                                    label="Email"
                                    variant="outlined"
                                    defaultValue={email}
                                    onChange={(e) => { setEmail(e.target.value) }}
                                    fullWidth
                                    color="secondary"
                                //helperText="Ingrese su email"
                                />
                            </div>

                            <div className="form-group">
                                <TextField
                                    required
                                    id="outlined-required"
                                    label="Contraseña"
                                    variant="outlined"
                                    defaultValue={password}
                                    onChange={(e) => { setPassword(e.target.value) }}
                                    fullWidth
                                    type="password"
                                />
                            </div>

                            <div class="custom-control custom-checkbox mb-3">
                                <FormGroup>
                                    <FormControlLabel control={<Switch onChange={(e) => { setCbkRecordar(e.target.checked) }} checked={cbkRecordar} />} label="¿Deseas que te recordemos?" />
                                </FormGroup>
                            </div>

                            <Button onClick={btnLogin} color="primary" fullWidth variant="contained">Iniciar</Button>
                            <br />
                            <br />
                            <p class="text-center">
                                <Link to="/forget">¿Has perdido la contraseña?</Link>
                                <br />
                                <Link to="/register">¿No tienes una cuenta?</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default Login;
